import { render } from "./Standings.vue?vue&type=template&id=42bd331c&scoped=true"
import script from "./Standings.vue?vue&type=script&lang=js"
export * from "./Standings.vue?vue&type=script&lang=js"

import "./Standings.vue?vue&type=style&index=0&id=42bd331c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-42bd331c"

export default script